/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

const LINE_ITEMS_PREFIX = 'lineItems.';

const DECIMAL_INDEX_PATTERN = /^(0|[1-9]\d*)$/;

export const isQrLineItemDotPathToken = token => {
  if (!token?.startsWith(LINE_ITEMS_PREFIX)) return false;

  const rest = token.slice(LINE_ITEMS_PREFIX.length);
  const dotIndex = rest.indexOf('.');

  if (dotIndex <= 0) return false;

  const indexSegment = rest.slice(0, dotIndex);

  if (!DECIMAL_INDEX_PATTERN.test(indexSegment)) return false;

  return rest.length > dotIndex + 1;
};
